import React from 'react';
import HeroSlider from '../HeroSlider/HeroSlider.jsx';
import News from '../News/News.jsx';
import SEOHelmet from '../SEO/SEOHelmet.jsx';
import { useTranslation } from 'react-i18next';
// import AI4Good from '../../components/AI4Good/AI4Good';
// import CookieManager from '../CookieConsent/CookieConsent.jsx'
// import Marquee from '../Marquee/marquee.jsx';
// import SvgMapComponent from '../GBA/svgmap.jsx';

const HomePage = () => {
  const { i18n } = useTranslation();
  
  const seoData = {
    en: {
      title: 'HONGKONG.AI - Leveraging AI for Society\'s Benefit | Hong Kong AI Hub',
      description: 'HONGKONG.AI dedicated to leveraging artificial intelligence for the improvement of people\'s lives and the benefit of society. Discover AI innovations, news, and resources.',
      keywords: 'Hong Kong AI, Artificial Intelligence, AI Society, Ethical AI, AI Innovation, Hong Kong Technology, AI for Good, Machine Learning, AI News, AI Resources'
    },
    'zh-HK': {
      title: 'HONGKONG.AI - 運用人工智能造福社會 | 香港人工智能中心',
      description: 'HONGKONG.AI 致力於運用人工智能改善人們的生活並造福社會。探索人工智能創新、新聞和資源。',
      keywords: '香港人工智能, 人工智能, AI社會, 道德AI, AI創新, 香港科技, AI造福, 機器學習, AI新聞, AI資源'
    },
    'zh-CN': {
      title: 'HONGKONG.AI - 运用人工智能造福社会 | 香港人工智能中心',
      description: 'HONGKONG.AI 致力于运用人工智能改善人们的生活并造福社会。探索人工智能创新、新闻和资源。',
      keywords: '香港人工智能, 人工智能, AI社会, 道德AI, AI创新, 香港科技, AI造福, 机器学习, AI新闻, AI资源'
    }
  };
  
  const currentLang = i18n.language || 'en';
  const currentSEO = seoData[currentLang] || seoData.en;
  
  return (
    <>
      <SEOHelmet
        title={currentSEO.title}
        description={currentSEO.description}
        keywords={currentSEO.keywords}
        url="/"
        type="website"
        image="/HK_1920x1080.jpg"
      />
      
      <main>
        <section id="hero" aria-label="Hero Section" data-track-section="hero">
          <HeroSlider />
        </section>
        
        <section id="news" aria-label="Latest News" data-track-section="news">
          <News />
        </section>
        
        {/* Future sections can be added here */}
        {/* <section id="solutions" aria-label="AI Solutions">
          <Marquee />
          <SvgMapComponent />
        </section> */}
      </main>
    </>
  );
};

export default HomePage;
